import styled from 'styled-components';
import {theme} from '@styles/theme';

export const ToastWrapper = styled.div<{type: string}>`
  display: flex;
  padding: 16px;
  gap: 8px;
  position: relative;
  align-items: center;
`;

export const IconWrapper = styled.div<{type: string}>`
  width: 22px;
  height: 22px;
  padding: 8px;
  border-radius: 32px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({type}) =>
    type == 'warn'
      ? theme.colors.signalOrange01
      : type == 'error'
        ? theme.colors.signalRed01
        : type == 'success'
          ? theme.colors.signalGreen01
          : theme.colors.basic06};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ToastData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ToastTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ActionWrapper = styled.div`
  display: flex;
`;
